const transformCartResponse = (data) => {
    if (data?.cart?.shipments?.length) {
        const shipmentById = data?.cart?.shipments?.reduce((acc, shipment) => ({
            ...acc,
            [shipment.id]: {
                ...shipment,
                articles: [],
            },
        }), {});
        const articles = data?.cart?.articles;
        articles?.forEach((article) => {
            // make it backwards compatible with cart-api v1
            if (!article.subscriptionDetails && article.lineItemDiscounts?.autoshipmentDiscount) {
                article.subscriptionDetails = {
                    ...article.lineItemDiscounts?.autoshipmentDiscount,
                };
            }
            if (!article.subscriptionApplied) {
                article.subscriptionApplied = article.lineItemDiscounts?.autoshipmentDiscount?.applied;
            }
            if (!article.subscriptionSelected) {
                article.subscriptionSelected = article.lineItemDiscounts?.autoshipmentDiscount?.selected;
            }
            if (!article.articleBasedVoucher && article.lineItemDiscounts?.articleBasedDiscount) {
                article.articleBasedVoucher = { ...article.lineItemDiscounts?.articleBasedDiscount };
            }
            if (!article.voucherApplied) {
                article.voucherApplied = article.lineItemDiscounts?.articleBasedDiscount?.applied;
            }
            if (!article.voucherSelected) {
                article.voucherSelected = article.lineItemDiscounts?.articleBasedDiscount?.selected;
            }
            shipmentById[article.shipmentId].articles?.push(article);
        });
        // we need to preserve the data.cart.shipments order
        data.cart.shipments = data?.cart?.shipments.map((shipment) => shipmentById[shipment.id]);
    }
    return data;
};

export { transformCartResponse };
//# sourceMappingURL=cart-utils.js.map
